<template>
  <modal
    title="Delete Location"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="delete-illustration-wrapper text-center">
      <img
        src="@/assets/images/delete-illustration.png"
        alt="Delete illustration"
        class="img-fluid"
      />
      <small
        >You are about to delete this Location. This action cannot be undone.
        Would you like to continue?</small
      >
    </div>
    <div class="actions">
      <p class="ext-darkBlue font-semibold cursor-pointer" @click="closeModal">
        Cancel
      </p>
      <base-button text="Delete" @click="deleteLocation" :loading="loading" />
    </div>
  </modal>
</template>

<script>
// import Modal from "@/components/partials/Modal/index";
export default {
  components: {
    // Modal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    location: {
      required: false,
    },
  },
  data() {
    return {
      selectedModule: null,
      moduleOptions: [],
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async deleteLocation() {
      this.loading = true;
      try {
        const response = await this.$_deleteLocation(this.location.id);
        this.log(response);
        this.generateToast("Location Deleted!", "success");
        this.$emit("deleted");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 0 1rem;
}
.actions button {
  padding: 0.25rem 0.75rem;
  border-radius: 3px;
}
.cancel-btn {
  color: #f57a4d;
}
.edit-btn {
  background: #f57a4d;
  color: #ffffff;
}
.delete-illustration-wrapper img {
  margin: 1rem auto;
  width: 4rem;
  height: auto;
}
</style>
